import { Outlet, useOutletContext } from 'react-router-dom'

import CollectionsBootstrap from 'modules/finance/lib/QuotesCollectionsBootstrap'

import { SalesRootPageOutletContext } from '../SalesRootPage'

const QuotesRootPage = () => {
  const accumulatedContext = useOutletContext<SalesRootPageOutletContext>()

  return (
    <CollectionsBootstrap>
      <Outlet context={{ ...accumulatedContext }} />
    </CollectionsBootstrap>
  )
}

export default QuotesRootPage
